import * as React from 'react';
import { Router, Route, Redirect } from 'react-router';
import { Provider } from 'react-redux';
import store, { history } from '../store';
import App from '../containers/App';
import SetRouteParams from '../containers/SetRouteParams';
import Home from '../containers/Home';
import StaticPageRouter from '../containers/StaticPage/Router';
import NotFoundPage from '../components/NotFoundPage';
import ViewDriveItemPage from '../containers/ViewDriveItemPage';
import DriveItemListPage from '../containers/DriveItemListPage';
import DriveItemDetailPage from '../containers/DriveItemDetailPage';
import ParametersPage from '../components/ParametersPage';
import ProfilePage from '../containers/ProfilePage';
import TheaterPage from '../containers/TheaterPage';
import SharePage from '../containers/SharePage';
import Editor from '../containers/Editor';
import ProposalStatsPage from '../containers/ProposalStatsPage';
import NotesPage from '../containers/NotesPage';
import RoutesUtils from '../utils/routes';

import { RoutePath } from './constants';
import Authentication from '../containers/Authentication';

const routes = () => (
	<Provider store={store}>
		<Router history={history}>
			<Redirect from={RoutePath.Default} to={RoutesUtils.getPathHome()} />
			<Route path={RoutePath.Default} component={SetRouteParams(App)}>

				<Route path={RoutePath.Home} component={Home} />
				<Route path={RoutePath.ViewDriveItem} component={ViewDriveItemPage} />
				<Route path={RoutePath.StaticPage} component={StaticPageRouter} />
				<Route path={RoutePath.ParametersPage} component={ParametersPage} />
				<Route path={RoutePath.ProfilePage} component={ProfilePage} />
				<Route path={RoutePath.ProposalStatsPage} component={ProposalStatsPage} />
				<Route path={RoutePath.DriveItemListPage} component={DriveItemListPage} />
				<Route path={RoutePath.TheaterList} component={DriveItemListPage} />
				<Route path={RoutePath.Theater} component={TheaterPage} />
				<Route path={RoutePath.Authentication} component={Authentication} />
				<Route path={RoutePath.DriveItemDetailPage} component={DriveItemDetailPage} />
				<Route path={RoutePath.Editor} component={Editor} />
				<Route path={RoutePath.NotesPage} component={NotesPage} />
				<Route path={RoutePath.SharePage} component={SharePage} />

				<Route path="*" component={NotFoundPage} />
			</Route>
		</Router>
	</Provider>
);

export default routes;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routes/index.tsx